
import { NumericCompareFn } from "../../shared/components/sort-field/sort-field.component"
import { MapImageOverlay, MapPointInterface } from "./mapping"
import { Task } from "./task"

export class ScoutPointPhoto {
  _id: string
  scoutPointId: string
  userId: string
  uploadDate: string // if not set and we have fileName, then photo needs to be uploaded from local store
  modifiedDate: string // any photo property changes trigger new value (notes, fileName, etc...)
  fileName : string
  fileChecksum?: string // for making sure cache is getting right version of file
  mimeType : string
  notes : string

  group ?: string // measurement, wide-angle, point-to-point
  groupOrderIndex?: number // display photos in specific order
  pointType ?: string // if scout point type was changed in editor, we need to let user delete photos of old type (optional)

  title?: string // Photos of type EX or HA show title if photo.type==scoutPoint.type
}

export class ScoutPointLocalPhoto {
  _id: string
  checksum: string
  name: string
  date: string
  uploadDate: string
  uploadStartDate: string // way to mark upload as in progress
  errorMsg: string
  retryCnt: number // track how many times failed when trying to upload
}
export class ScoutPointLocalPhotoUrl {
  _id: string
  url: string
}

export class ScoutPointRefData {
  location1Distance : number
  location2Distance : number
}

export class ScoutPointEnvData {
  pointDescription? : string
  bInterior? : boolean = true
  windowCount? : number = 0 // within 25' Radius
  clutterDescription? : string
  hvacDescription? : string
  nearestWindowDistance : number
  floorToCeilingHeight: number
  quadrant?: string
}

export class ScoutPointError {
  implConstant: number
  implEstimate: number
  segmentEstimate: number
  cumulativeEstimate: number
}

export class ScoutPointHorizontalError extends ScoutPointError {
  derivedFromExternalWall?: boolean
  externalWallAngleConstant: number
  measuredAngleConstant: number
  externalWallAngleEstimate: number
  measuredAngleEstimate: number
}

export class ScoutPointVerticalError extends ScoutPointError {
  unlevelFloor?: boolean
  floorVarianceConstant: number
  unlevelFloorConstant: number
  floorVarianceEstimate: number
  unlevelFloorEstimate: number
}

export class ScoutPoint implements MapPointInterface{
  id: string
  type : string
  pointId ?: string
  horizontalDistance ?: number
  bearing ?: number
  heightOffset ?: number
  parentId: string
  latitude?: number
  longitude?: number
  altitudeEllipsoidMeters?: number
  exPointId?: string // proposed point id when scout point is approved as EX point (added to point table)
  refData ?: ScoutPointRefData
  envData ?: ScoutPointEnvData

  horizontalError? : ScoutPointHorizontalError
  verticalError? : ScoutPointVerticalError
  disabled?: boolean

  //TBD temp variables or save in document?
  order ?: number
  name ?: string
  color ?: string
  parentName?: string
  parentColor?: string
  bNew?: boolean
}


export class ScoutPathComment {
  id: string
  text: string
  timestamp: string
  archived: boolean
  userId: string
}

export class Azimuth {
  id: string
  angle: number = 0
  title: string = ''
}

export class ScoutPath {
  id : string
  floor ?: string
  azimuthCorner ?: string
  azimuth1Angle ?: number
  azimuth2Angle ?: number
  addlAzimuths?: Azimuth[]
  modifiedDate: string
  userId: string
  description: string
  scoutPoints: ScoutPoint[] = []
  comments: ScoutPathComment[] = []
  overlay ?: MapImageOverlay
  statusId: number
  pathNumber ?: number

  static sortByPathNumber = ( paths: ScoutPath[] ) => paths?.sort(ScoutPath.comparePathNumbers)
  static comparePathNumbers = (a: ScoutPath, b: ScoutPath) => NumericCompareFn(a.pathNumber,b.pathNumber) || ScoutPath.compareModifiedDates(a,b)
  static compareModifiedDates = (a: ScoutPath, b: ScoutPath) => (a.modifiedDate < b.modifiedDate) ? -1 : (a.modifiedDate > b.modifiedDate) ? 1 : 0
}


export class ScoutTask extends Task {

  constructor(){
    super()
    this.type = "scout"
  }

  scoutPaths : ScoutPath[]

}